export const AA_ENABLED_BANNER_MESSAGE = [
  'When you log in. Like rescheduling your booked appointments. ',
  'You can also see your whole order, full site address, and site contact details.',
];
export const AA_DISABLED_BANNER_MESSAGE =
  'When you log in like seeing your whole order, full site address, and site contact details.';
